<template>
  <div class="my-table projectSetting">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('authoritySettings.txt1')}}</span>
        <span>{{$t('authoritySettings.txt2')}} / {{$t('authoritySettings.txt3')}} /  
          <span class="link">{{detail.projectName}} / {{$t('authoritySettings.txt4')}}</span>
        </span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('authoritySettings.txt5')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('authoritySettings.txt4')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn" @click="setFilePermission">{{$t('authoritySettings.txt6')}}</div>
        </div>
      </div>
      <div class="editForm editWidth">
        <el-form :model="projectParams" :rules="projectRules" ref="projectParams" class="demo-ruleForm">
          <el-form-item label="" prop="lanIp">
            <div class="radioBox">
              <div class="settingTitle">{{$t('authoritySettings.txt7')}}</div>
              <el-row :gutter="10">
                <el-col :span="8">
                  <p>{{$t('authoritySettings.txt8')}}</p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt9')}}</span>
                    <el-switch v-model="queryData.filePermission.userDownload" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt10')}}</span>
                    <el-switch v-model="queryData.filePermission.userEdit" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt11')}}</span>
                    <el-switch v-model="queryData.filePermission.userView" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>{{$t('authoritySettings.txt12')}}</p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt9')}}</span>
                    <el-switch v-model="queryData.filePermission.groupDownload" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt10')}}</span>
                    <el-switch v-model="queryData.filePermission.groupEdit" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt11')}}</span>
                    <el-switch v-model="queryData.filePermission.groupView" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>{{$t('authoritySettings.txt13')}}</p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt9')}}</span>
                    <el-switch v-model="queryData.filePermission.otherDownload" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt10')}}</span>
                    <el-switch v-model="queryData.filePermission.otherEdit" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('authoritySettings.txt11')}}</span>
                    <el-switch v-model="queryData.filePermission.otherView" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        queryData:{
          filePermission:{
            groupDownload: false,
            groupEdit: false,
            groupView: false,
            otherDownload: false,
            otherEdit: false,
            otherView: false,
            userDownload: false,
            userEdit: false,
            userView: false
          },
          projectId:this.$route.query.id,
          file:this.$route.query.file,
        },
        detail:{},
        projectParams:{},
        projectRules:{},
        checkList:[]
      };
    },
    created() {
      this.getFilePermission();
    },

    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 获取文件权限
      async getFilePermission() {
        let data = {
          projectId: this.queryData.projectId,
          file:this.queryData.file
        }
        const {
          data: res
        } = await this.$http.post("/project/getFilePermission?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.queryData = res.result;
      },
      // 设置文件权限
      async setFilePermission() {
        console.log(this.queryData,'this.queryData')
        const {
          data: res
        } = await this.$http.post("/project/setFilePermission",this.queryData);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
        	type: 'success',
        	message: this.$t('authoritySettings.txt14')
        });
        this.onBack();
      },
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .projectSetting{
    /deep/ .el-upload__input{
      display: none !important;
    }
    .mr10{
      margin-right: 10px;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .editForm{
      margin: 0;
      width: 70%;
    }
    .projectName{
      padding-bottom: 30px;
      border-bottom: 1px solid #EBF7F4;
    }
    .settingTitle{
      font-weight: 500;
      color: #222222;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .radioBox{
      p{
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
  }

</style>
